







































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import mainLandPackageList from '@/store/entities/back-mainlandpackage'
    import QRcode from 'qrcodejs2'
    class AddWeight {
        id: number;
        cargoCategory: number;
        productLong: number;
        productWide: number;
        productHigh: number;
        productWeight: number;
        site: number;
        isAdd: boolean;
    }
    @Component
    export default class WeightInput extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        Weight: AddWeight = new AddWeight();
        cargoCategoryType = Enums.CargoCategoryType;
        SiteSType = Enums.SiteSType;
        result: number = 0;
        packageName: string = "";
        type: number = 0;
        ExtraServiceList: Array<string> = ["拆分订单", "组合订单", "超大件打包"];
 
        isShow: number;

        async save() {
            (this.$refs.weightForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.Weight.id = this.$store.state.backstock.id;
                    this.Weight.isAdd = true;
                    if (this.Weight.productWeight >= 0) {
                        this.result = await this.$store.dispatch({
                            type: 'backstock/GetHeadFee',
                            data: this.Weight
                        });
                        (this.$refs.weightForm as any).resetFields();

                        this.$emit('save-success');
                        this.$emit('input', false);
                    }

                }
            })


        }

        async enter() {
            var _this = this;
            if (this.Weight.productLong == null) {
                //this.$refs[0].['longfocus'][0].focus()
                //this.$nextTick(() => {
                //    this.$refs.longfocus.focus();
                //})
                var data: any = this.$refs.longfocus;
                data.focus();
            }
            else if (this.Weight.productWide == null) {
                //this.$refs['widefocus'][0].focus()

                //this.$nextTick(() => {
                //    this.$refs.widefocus[0].focus();
                //})
                var data: any = this.$refs.widefocus;
                data.focus();
            }
            else if (this.Weight.productHigh == null) {
                //this.$refs['highfocus'][0].focus()
                //_this.$refs.highfocus.focus();
                var data: any = this.$refs.highfocus;
                data.focus();
            }
            else if (this.Weight.productWeight == null) {
                //this.$refs['resultWeightfocus'][0].focus()
                //this.$refs.resultWeightfocus[0].focus();
                var data: any = this.$refs.resultWeightfocus;
                data.focus();
            }

        }

        async requestMethod() {
            var number = 0;
            this.Weight.id = this.$store.state.backstock.id;
            this.Weight.site = this.$store.state.backstock.orderSite;
            this.Weight.isAdd = false;
            if (this.Weight.productWeight>=0) {
                number = await this.$store.dispatch({
                    type: 'backstock/GetHeadFee',
                    data: this.Weight
                })
            }
            if (number >= 0) {
                this.result = number;
            }
          
        }
        async longChange(val: any) {
            this.requestMethod();
        }
        async wideChange(val: any) {
            this.requestMethod();
        }
        async highChange(val: any) {
            this.requestMethod();
        }
        async weightChange(val: any) {
            this.requestMethod();
        }


        cancel() {
            (this.$refs.weightForm as any).resetFields();
            this.result = 0;
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            (this.$refs.weightForm as any).resetFields();
            this.result = 0;
            if (!value) {
                this.$emit('input', value);
            } else {
                
            }
        }
        validateSequence = (rule, value, callback) => {
            let regNum = /^.{1,5}$/;
            if (value === '') {
                if (rule.field == 'resultWeight') {
                    callback(new Error('不能为空（g）'));
                }
                else {
                    callback(new Error('不能为空（CM）'));
                }

            } else if (!Number.isInteger(+value)) {
                callback(new Error('输入数字'));
            } else if (!regNum.test(value)) {
                callback(new Error('长度过长'));
            } else {
                callback();
            }
        };

        WeightRule = {
            long: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            wide: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            high: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
            resultWeight: [
                { required: true, validator: this.validateSequence, trigger: 'blur' }
            ],
        };

        created() {
           
        }
    }
